import config from '../config';
import { loadTaskById, deleteTasksByIds } from '../actions/tasks';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';

export function fetchTaskById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadTaskById({ task: json }));
          }
        })        
    }
  }
};

export function removeTasksWithIds(data) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetch(`${config.apiEndpoint}/task/tasks/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': `bearer ${userAuth.api_token}`
                },
                body: JSON.stringify({ids: data.id}),
                credentials: 'same-origin'
            })
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json && json.success) {
                        dispatch(deleteTasksByIds({ ids: data.id }));
                        dispatch(notify({
                            title: 'Delete Project tasks',
                            message: 'Project tasks deleted successfully',
                            status: 'success',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                    }else {
                        dispatch(notify({
                            title: 'An Error occurred',
                            message: json.title,
                            status: 'error',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                    }
                })
        }
    }
};



// WEBPACK FOOTER //
// ./src/api/tasks.js